(function () {
  var root = document.querySelector('[data-rbw-advisor]');
  if (!root) return;
  var dataEl = document.getElementById('rbw-advisor-data');
  if (!dataEl) return;
  var MODELS = [];
  try { MODELS = JSON.parse(dataEl.textContent) || []; } catch (e) { return; }
  MODELS = MODELS.filter(function (m) { return m && m.url; });
  if (!MODELS.length) { root.style.display = 'none'; return; }

  function track(name, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload || {}));
      document.dispatchEvent(new CustomEvent('rbw:' + name, { detail: payload || {} }));
    } catch (e) {}
  }

  var QUESTIONS = [
    { id: 'gebruik', q: 'Waarvoor ga je de boot vooral gebruiken?', opts: [
      { v: 'recreatief', l: 'Recreatief varen' },
      { v: 'vissen', l: 'Vissen' },
      { v: 'bijboot', l: 'Als bijboot bij een grotere boot' },
      { v: 'hond', l: 'Met de hond mee' },
      { v: 'weetniet', l: 'Een beetje van alles' }
    ] },
    { id: 'personen', q: 'Met hoeveel personen vaar je meestal?', hint: 'Maximaal aantal personen volgens het CE-bouwplaatje: 280-modellen 2, 330-modellen 4.', opts: [
      { v: 1, l: 'Meestal alleen' },
      { v: 2, l: 'Met z’n tweeën' },
      { v: 3, l: 'Met z’n drieën' },
      { v: 4, l: 'Met z’n vieren' }
    ] },
    { id: 'aandrijving', q: 'Hoe wil je varen?', opts: [
      { v: 'roeien', l: 'Roeien, zonder motor' },
      { v: 'elektrisch', l: 'Met een elektromotor' },
      { v: 'benzine', l: 'Met een benzinemotor' },
      { v: 'weetniet', l: 'Weet ik nog niet' }
    ] },
    { id: 'vermogen', q: 'Heb je al een idee hoeveel pk?', hint: 'Geen idee? Geen probleem — dan kiezen wij de passende motor erbij.',
      when: function (a) { return a.aandrijving === 'benzine'; }, opts: [
      { v: 'b2535', l: '2,5 – 3,5 pk' },
      { v: 'b46', l: '4 – 6 pk' },
      { v: 'b810', l: '8 – 10 pk' },
      { v: 'b15', l: '15 pk' },
      { v: 'weetniet', l: 'Weet ik nog niet' }
    ] },
    { id: 'opbouw', q: 'Hoe vaak bouw je de boot op en af?', opts: [
      { v: 'elkekeer', l: 'Elke keer — hij gaat mee in de auto' },
      { v: 'afentoe', l: 'Af en toe' },
      { v: 'blijft', l: 'Bijna nooit — hij blijft opgebouwd' }
    ] },
    { id: 'staand', q: 'Sta je wel eens rechtop in de boot?', hint: 'Bijvoorbeeld om te vissen of om aan te leggen.', opts: [
      { v: 'regelmatig', l: 'Ja, regelmatig' },
      { v: 'soms', l: 'Af en toe' },
      { v: 'nee', l: 'Nee, ik blijf zitten' }
    ] }
  ];

  var AFFINITY = {
    recreatief: { '180-SL': -2, '230-AIR': 0, '280-SL': 4, '280-AIR': 3.5, '330-SL': 4, '330-AL': 3 },
    vissen: { '180-SL': 4, '230-AIR': 4, '280-SL': 2.5, '280-AIR': 1, '330-SL': 1.5, '330-AL': 1.5 },
    bijboot: { '180-SL': 2.5, '230-AIR': 5, '280-SL': 4.5, '280-AIR': 4, '330-SL': -3, '330-AL': -6 }
  };

  var BAND = { b2535: [2.5, 3.5], b46: [4, 6], b810: [8, 10], b15: [15, 15] };
  var HP_LABEL = { b2535: 'motor van 2,5 tot 3,5 pk', b46: 'motor van 4 tot 6 pk', b810: 'motor van 8 tot 10 pk', b15: '15 pk motor' };

  var answers = {};
  var started = false;
  var index = 0;

  function use() { return answers.gebruik; }
  function flow() { return QUESTIONS.filter(function (q) { return !q.when || q.when(answers); }); }
  function nextIndex() {
    var f = flow();
    for (var i = 0; i < f.length; i++) { if (typeof answers[f[i].id] === 'undefined') return i; }
    return -1;
  }

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return '€ ' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }
  function nl(n) { return String(n).replace('.', ','); }

  function neededHp() {
    if (answers.aandrijving === 'benzine') { var b = BAND[answers.vermogen]; return b ? b[0] : 0; }
    if (answers.aandrijving === 'elektrisch') return 3;
    return 0;
  }

  function eligible() {
    var need = neededHp();
    var pers = answers.personen || 1;
    var list = MODELS.filter(function (m) { return m.maxhp >= need && m.persons >= pers; });
    if (list.length) return list;
    var byPers = MODELS.filter(function (m) { return m.persons >= pers; });
    if (byPers.length) return byPers;
    var maxP = Math.max.apply(null, MODELS.map(function (m) { return m.persons; }));
    return MODELS.filter(function (m) { return m.persons === maxP; });
  }

  function score(m) {
    var s = 0;
    var u = use(), ob = answers.opbouw, st = answers.staand, ad = answers.aandrijving;
    if (AFFINITY[u] && typeof AFFINITY[u][m.code] === 'number') s += AFFINITY[u][m.code];
    if (u === 'vissen') s += m.stability * 1.5 + m.rigid;
    if (u === 'bijboot') s += m.portability * 2;
    if (u === 'hond') { if (m.floor === 'AL') s += 8; else if (m.floor === 'SL') s += 4; else s -= 6; }
    if (!u || u === 'weetniet') s += (m.stability + m.portability + m.setup) * 0.9;
    if (ob === 'elkekeer') s += m.portability * 3.5 + m.setup * 3;
    if (ob === 'afentoe') s += m.portability * 1.5 + m.setup * 1.5;
    if (ob === 'blijft') s += m.stability * 2;
    if (st === 'regelmatig') s += m.stability * 4 + m.rigid * 2;
    if (st === 'soms') s += m.stability * 1.5 + m.rigid;
    if (st === 'nee') s += m.portability * 0.5;
    if (ad === 'roeien') s += m.portability * 1.5;
    var head = m.persons - (answers.personen || 1);
    s += head === 0 ? 2 : (head === 1 ? 3 : 1);
    if (m.qty > 0) s += 2.5; else s -= 3;
    s += m.price / 60000;
    return s;
  }

  function shaftRank(v) {
    var t = (v.variantTitle || '').toLowerCase();
    if (t.indexOf('extra kort') !== -1) return 2;
    if (t.indexOf('kort') !== -1) return 0;
    if (t.indexOf('lang') !== -1) return 3;
    return 1;
  }

  function pickMotor(m) {
    var ad = answers.aandrijving;
    if (ad !== 'elektrisch' && ad !== 'benzine') return null;
    var list = (m.motors || []).filter(function (x) { return x && x.name && x.variantId; });
    if (!list.length) return null;

    if (ad === 'elektrisch') {
      var el = list.filter(function (x) { return (x.fuel || '').toLowerCase().indexOf('elek') === 0; });
      if (!el.length) return null;
      var wantLight = answers.opbouw === 'elkekeer' || use() === 'bijboot';
      el.sort(function (a, b) {
        var d = wantLight ? (a.watt || 0) - (b.watt || 0) : (b.watt || 0) - (a.watt || 0);
        if (d) return d;
        d = shaftRank(a) - shaftRank(b);
        if (d) return d;
        return a.price - b.price;
      });
      return el[0];
    }

    var pet = list.filter(function (x) {
      return (x.fuel || '').toLowerCase().indexOf('benz') === 0 && typeof x.hp === 'number' && x.hp <= m.maxhp;
    });
    if (!pet.length) return null;
    var band = BAND[answers.vermogen];
    var pool = band ? pet.filter(function (x) { return x.hp >= band[0] && x.hp <= band[1]; }) : [];
    if (!pool.length) pool = pet;
    var target = band ? band[1] : (m.rechp || m.maxhp);
    pool.sort(function (a, b) {
      var d = Math.abs(a.hp - target) - Math.abs(b.hp - target);
      if (d) return d;
      d = shaftRank(a) - shaftRank(b);
      if (d) return d;
      return a.price - b.price;
    });
    return pool[0];
  }

  function motorReason(m, mo) {
    var bits = [];
    if (typeof mo.hp === 'number') {
      bits.push(nl(mo.hp) + ' pk, binnen de ' + nl(m.maxhp) + ' pk die de ' + m.code + ' mag voeren');
    } else if (mo.watt) {
      bits.push('stil en onderhoudsvrij, en met ' + mo.watt + ' W ruim binnen de ' + nl(m.maxhp) + ' pk van de ' + m.code);
    }
    if (shaftRank(mo) === 0 && m.transom) {
      bits.push('kortstaart, passend bij de spiegelhoogte van ' + nl(m.transom) + ' cm');
    }
    if (!bits.length) return '';
    return bits.join(' — ') + '.';
  }

  function reasons(m) {
    var out = [];
    var u = use();
    out.push('Toegelaten voor ' + m.persons + ' personen en ' + m.load + ' kg, ruim genoeg voor hoe jij meestal vaart.');
    if (answers.aandrijving === 'benzine' && answers.vermogen && answers.vermogen !== 'weetniet') {
      out.push('Mag een motor tot ' + nl(m.maxhp) + ' pk voeren, dus jouw ' + HP_LABEL[answers.vermogen] + ' past hierop.');
    } else if (answers.aandrijving === 'roeien') {
      out.push('Je vaart nu op de riemen, maar er mag later alsnog een motor tot ' + nl(m.maxhp) + ' pk op.');
    }
    if (u === 'bijboot') {
      out.push(m.len + ' cm lang en ' + m.weight + ' kg — compact en licht genoeg om als bijboot mee te nemen of aan davits te hangen.');
    }
    if (u === 'hond' && m.rigid >= 2) {
      out.push('Een ' + m.floorLabel.toLowerCase() + ' ligt vast en is bestand tegen hondennagels, anders dan een opblaasbare vloer.');
    }
    if (answers.opbouw === 'elkekeer') {
      out.push('Weegt ' + m.weight + ' kg — met z’n tweeën goed te tillen en mee te nemen in de auto.');
      if (m.floor === 'AIR') out.push('De airdeck-vloer pomp je op, je hoeft geen losse latten te plaatsen.');
    }
    if ((answers.staand === 'regelmatig' || u === 'vissen') && m.stability >= 3) {
      out.push(m.width + ' cm breed met een ' + m.floorLabel.toLowerCase() + ', stabiel genoeg om rechtop te staan.');
    }
    if (u === 'recreatief' && m.persons >= 4) {
      out.push('Met ' + m.len + ' × ' + m.width + ' cm zit je met meerdere personen ruim, ook met bagage aan boord.');
    }
    if (!answers.aandrijving || answers.aandrijving === 'weetniet') {
      out.push('Mag een motor tot ' + nl(m.maxhp) + ' pk voeren, dus je houdt ruimte om de motor later te kiezen.');
    }
    if (out.length < 3) out.push('Afmetingen ' + m.len + ' × ' + m.width + ' cm bij ' + m.weight + ' kg, met een ' + m.floorLabel.toLowerCase() + '.');
    if (out.length < 3) out.push('Drielaags pvc van 1000 denier en 2 jaar garantie op fabricagefouten, net als elke Selakos.');
    return out.slice(0, 4);
  }

  function tradeoff(m) {
    var t = m.tradeoff;
    if (use() === 'hond' && m.rigid === 0) {
      t += ' Met een hond aan boord adviseren wij een aluminium vloer, of anders een lattenbodem — niet een opblaasbare airdeck.';
    }
    return t;
  }

  function renderQuestion() {
    var f = flow();
    if (index >= f.length) index = f.length - 1;
    if (index < 0) index = 0;
    var q = f[index];
    var pct = Math.round((index / f.length) * 100);
    var html = '<div class="rbw-adv__progress"><div class="rbw-adv__bar"><span style="width:' + pct + '%"></span></div>' +
      '<div class="rbw-adv__step">Vraag ' + (index + 1) + ' van ' + f.length + '</div></div>' +
      '<h3 class="rbw-adv__q">' + esc(q.q) + '</h3>';
    if (q.hint) html += '<p class="rbw-adv__sub" style="font-size:14px;margin:-12px 0 18px">' + esc(q.hint) + '</p>';
    html += '<div class="rbw-adv__opts" role="group">';
    q.opts.forEach(function (o) {
      var on = String(answers[q.id]) === String(o.v);
      html += '<button type="button" class="rbw-adv__opt" aria-pressed="' + (on ? 'true' : 'false') + '" data-v="' + esc(o.v) + '">' + esc(o.l) + '</button>';
    });
    html += '</div><div class="rbw-adv__nav"><button type="button" class="rbw-adv__back"' + (index === 0 ? ' hidden' : '') + '>← Vorige vraag</button></div>';
    root.innerHTML = html;

    root.querySelectorAll('.rbw-adv__opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var raw = b.getAttribute('data-v');
        answers[q.id] = /^\d+$/.test(raw) ? parseInt(raw, 10) : raw;
        if (q.id === 'aandrijving' && raw !== 'benzine') delete answers.vermogen;
        if (!started) { started = true; track('boat_advisor_started', {}); }
        track('boat_advisor_answer', { question: q.id, answer: raw });
        var n = nextIndex();
        if (n === -1) { renderResults(); } else { index = n; renderQuestion(); }
      });
    });
    var back = root.querySelector('.rbw-adv__back');
    if (back) back.addEventListener('click', function () { if (index > 0) { index--; renderQuestion(); } });
  }

  function motorBlock(m, mo) {
    if (!mo) return '';
    var reason = motorReason(m, mo);
    var total = m.price + mo.price;
    return '<div style="display:flex;gap:14px;align-items:flex-start;background:#f9f7f3;border:1px solid #e3ddd1;border-radius:10px;padding:14px;margin:0 0 16px">' +
      (mo.image ? '<img src="' + esc(mo.image) + '" alt="' + esc(mo.name) + '" loading="lazy" style="width:78px;height:78px;object-fit:contain;flex:0 0 auto;mix-blend-mode:multiply">' : '') +
      '<div style="min-width:0">' +
      '<p style="margin:0 0 3px;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#8a6a30">Hier past deze motor bij</p>' +
      '<h4 style="margin:0 0 2px;font-size:16px">' + esc(mo.name) + '</h4>' +
      '<p style="margin:0;font-size:14px;color:#5f6b74">' + esc(mo.variantTitle || '') + ' · ' + money(mo.price) + '</p>' +
      (reason ? '<p style="margin:6px 0 0;font-size:14px;line-height:1.45">' + esc(reason) + '</p>' : '') +
      '<p style="margin:8px 0 0;font-size:14px;line-height:1.45"><b>Samen ' + money(total) + '</b> — bestel je boot en motor samen, dan rekent de winkelwagen automatisch 10% combi-deal korting.</p>' +
      '</div></div>';
  }

  function cardPrimary(m, mo) {
    var stock;
    if (m.qty > 0) {
      stock = '<p class="rbw-adv__stock">Op voorraad — direct leverbaar</p>';
    } else if (m.available) {
      stock = '<p class="rbw-adv__stock">Leverbaar op bestelling — vraag ons naar de levertijd</p>';
    } else {
      stock = '<p class="rbw-adv__stock rbw-adv__stock--out">Tijdelijk uitverkocht — neem contact op voor de levertijd</p>';
    }
    var specs = ['<li>' + m.len + ' × ' + m.width + ' cm</li>', '<li>' + m.weight + ' kg</li>', '<li>' + esc(m.floorLabel) + '</li>',
      '<li>max. ' + m.persons + ' personen</li>', '<li>max. ' + nl(m.maxhp) + ' pk</li>', '<li>' + m.load + ' kg laadvermogen</li>'].join('');
    var why = reasons(m).map(function (r) { return '<li>' + esc(r) + '</li>'; }).join('');

    var canAddBoat = m.available && m.variantId && m.variantCount === 1;
    var cart;
    if (canAddBoat && mo && mo.available) {
      cart = '<button type="button" class="rbw-adv__btn rbw-adv__btn--cart" data-add="' + m.variantId + '" data-add2="' + mo.variantId + '">Boot + motor in winkelwagen</button>';
    } else if (canAddBoat) {
      cart = '<button type="button" class="rbw-adv__btn rbw-adv__btn--cart" data-add="' + m.variantId + '">In winkelwagen</button>';
    } else {
      cart = '<a class="rbw-adv__btn rbw-adv__btn--cart" href="' + esc(m.url) + '" data-click="' + esc(m.code) + '">' + (m.variantCount > 1 ? 'Kies je kleur' : 'Bekijk deze boot') + '</a>';
    }

    var combiHref = '/pages/combi-deal?boot=' + encodeURIComponent(m.handle);
    if (mo) combiHref += '&motor=' + encodeURIComponent(mo.variantId);

    return '<div class="rbw-adv__primary"><div class="rbw-adv__ribbon">Onze aanbeveling voor jou</div><div class="rbw-adv__body">' +
      '<div class="rbw-adv__media">' + (m.image ? '<img src="' + esc(m.image) + '" alt="' + esc(m.name) + '" loading="lazy" width="600" height="600">' : '') + '</div>' +
      '<div><h3 class="rbw-adv__name">' + esc(m.name) + '</h3><p class="rbw-adv__price">' + money(m.price) + '</p>' + stock +
      '<ul class="rbw-adv__specs">' + specs + '</ul>' +
      '<ul class="rbw-adv__why">' + why + '</ul>' +
      motorBlock(m, mo) +
      '<p class="rbw-adv__note"><b>Goed om te weten:</b> ' + esc(tradeoff(m)) + '</p>' +
      '<div class="rbw-adv__cta">' + cart +
      '<a class="rbw-adv__btn rbw-adv__btn--ghost" href="' + esc(m.url) + '" data-click="' + esc(m.code) + '">Bekijk deze boot</a>' +
      '<a class="rbw-adv__btn rbw-adv__btn--link" href="' + esc(combiHref) + '" data-combi="' + esc(m.code) + '">Stel complete set samen</a>' +
      '</div></div></div></div>';
  }

  function cardAlt(m) {
    return '<div class="rbw-adv__alt"><div class="rbw-adv__alt-media">' + (m.image ? '<img src="' + esc(m.image) + '" alt="' + esc(m.name) + '" loading="lazy">' : '') + '</div>' +
      '<h4>' + esc(m.name) + '</h4><p>' + money(m.price) + ' · ' + m.weight + ' kg · ' + esc(m.floorLabel) + ' · max. ' + m.persons + ' pers.</p>' +
      '<p>' + esc(m.tradeoff) + '</p>' +
      '<a href="' + esc(m.url) + '" data-click="' + esc(m.code) + '">Bekijk deze boot →</a></div>';
  }

  function renderResults() {
    var ranked = eligible().map(function (m) { return { m: m, s: score(m) }; })
      .sort(function (a, b) { return b.s - a.s; }).map(function (x) { return x.m; });
    var top = ranked[0];
    var motor = pickMotor(top);
    var alts = ranked.slice(1, 3);
    track('boat_advisor_completed', { answers: answers });
    track('boat_advisor_recommendation', { primary: top.code, motor: motor ? motor.name : null, alternatives: alts.map(function (a) { return a.code; }) });

    var html = '<div class="rbw-adv__progress"><div class="rbw-adv__bar"><span style="width:100%"></span></div><div class="rbw-adv__step">Klaar</div></div>' +
      '<div class="rbw-adv__results">' + cardPrimary(top, motor);
    if (alts.length) {
      html += '<div><h4 class="rbw-adv__q" style="font-size:18px;margin:6px 0 12px">Ook de moeite waard om te vergelijken</h4><div class="rbw-adv__alts">' +
        alts.map(cardAlt).join('') + '</div></div>';
    }
    html += '</div><div class="rbw-adv__restart"><button type="button" class="rbw-adv__back" data-restart>Opnieuw beginnen</button></div>';
    root.innerHTML = html;

    var restart = root.querySelector('[data-restart]');
    if (restart) restart.addEventListener('click', function () { answers = {}; index = 0; started = false; renderQuestion(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

    root.querySelectorAll('[data-click]').forEach(function (a) {
      a.addEventListener('click', function () { track('boat_advisor_product_click', { model: a.getAttribute('data-click') }); });
    });
    root.querySelectorAll('[data-combi]').forEach(function (a) {
      a.addEventListener('click', function () { track('combideal_click', { model: a.getAttribute('data-combi'), motor: motor ? motor.name : null, source: 'boat_advisor' }); });
    });

    var addBtn = root.querySelector('[data-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [{ id: Number(addBtn.getAttribute('data-add')), quantity: 1 }];
        var second = addBtn.getAttribute('data-add2');
        if (second) items.push({ id: Number(second), quantity: 1 });
        var label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Bezig…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart');
          return r.json();
        }).then(function () {
          track('add_to_cart', { source: 'boat_advisor', model: top.code, motor: motor ? motor.name : null, items: items.length });
          window.location.href = '/cart';
        }).catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = label;
          window.location.href = top.url;
        });
      });
    }
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { track('boat_advisor_view', {}); io.disconnect(); } });
    }, { threshold: 0.25 });
    io.observe(root);
  }

  renderQuestion();
})();
